<template>
  <div class="bar">
    <div class="bar-header">
      <div class="logo"></div>
      <div class="contact" v-if="theatre.SupportPhone">
        <div class="contact-label">Служба поддержки</div>
        <div class="contact-number">{{ theatre.SupportPhone }}</div>
      </div>
      <div v-if="this.user.sessionEndAt" class="timer">
        <div class="timer-label">Осталось</div>

        <div class="timer-time">
          <Timer
            starttime="Sep 4, 2018 18:00:00"
            :endtime="this.user.sessionEndAt"
            trans='{
           "day":"Дней",
           "hours":"Часов",
           "minutes":"Минут",
           "seconds":"Секунд",
           "expired":"Event has been expired.",
           "running":"До конца сессии",
           "upcoming":"С начала сессии",
           "status": {
              "expired":"Истек",
              "running":"Запущен",
              "upcoming":"Future"
             }}'
          ></Timer>
        </div>
      </div>
      <div class="button-back" @click="goBack">
        <span class="btn-icon fa fa-long-arrow-left"></span>
      </div>
    </div>
    <div class="bar-menu">
      <div
        class="bar-menu__item"
        v-for="(group, groupIndex) in groups"
        :key="'bar-group-' + groupIndex"
        @click="setCurrentGroupId(groupIndex)"
        :class="{ active: isActiveGroup(groupIndex) }"
      >
        {{ group.GroupName }}
      </div>
    </div>
    <div class="bar-body">
      <div
        class="bar-item mobile"
        v-for="(item, mobileIndex) in groupProducts"
        :key="'bar-item-mobile-' + currentGroupId + '-' + mobileIndex"
        :style="{ order: item.Number }"
      >
        <div class="image">
          <img :src="item.ImageUrl" :alt="item.Name" v-if="item.ImageUrl" />
          <svg
            v-else
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            version="1.1"
            id="Capa_1"
            x="0px"
            y="0px"
            viewBox="0 0 457.582 457.582"
            style="enable-background: new 0 0 457.582 457.582"
            xml:space="preserve"
            width="512px"
            height="512px"
          >
            <path
              d="M11.796,306.42h237.037c1.668,0,3.26-0.711,4.381-1.947s1.67-2.887,1.51-4.548c-4.563-47.249-58.519-84.545-124.41-84.545   S10.467,252.677,5.905,299.926c-0.161,1.662,0.385,3.315,1.507,4.552C8.533,305.715,10.126,306.42,11.796,306.42z"
              fill="#0d76ff"
            />
            <path
              d="M248.832,364.24H11.796c-1.67,0-3.262,0.706-4.384,1.942c-1.122,1.237-1.667,2.891-1.507,4.553   c1.243,12.86,6.148,24.982,13.955,35.816c5.03,6.979,13.114,11.109,21.718,11.109H219.05c8.59,0,16.695-4.14,21.717-11.109   c7.807-10.834,12.712-22.956,13.955-35.816c0.16-1.661-0.388-3.312-1.51-4.548S250.501,364.24,248.832,364.24z"
              fill="#0d76ff"
            />
            '
            <path
              d="M245.744,320.604H14.884C6.664,320.604,0,327.267,0,335.487c0,8.22,6.664,14.883,14.884,14.883h230.86   c8.22,0,14.883-6.664,14.883-14.883C260.627,327.267,253.963,320.604,245.744,320.604z"
              fill="#0d76ff"
            />
            <path
              d="M442.698,172.329c-2.108,0-3.332-2.311-2.22-4.102c1.378-2.222,2.188-4.833,2.219-7.634   c0.094-8.281-7.035-15.055-15.317-15.055h-63.196l4.921-68.878l52.885,22.49c7.782,3.31,16.813-0.519,19.787-8.542   c2.786-7.514-1.15-15.879-8.524-19.016L361.57,41.109c-4.425-1.881-9.486-1.51-13.587,0.998c-4.103,2.508-6.74,6.842-7.083,11.638   l-6.558,91.794h-63.777c-8.281,0-15.41,6.774-15.317,15.055c0.032,2.801,0.841,5.412,2.219,7.634   c1.111,1.791-0.113,4.102-2.22,4.102c-8.22,0-14.883,6.664-14.883,14.884c0,7.101,4.813,14.515,11.629,14.515   c56.444,0,138.568,0,193.96,0c6.816,0,11.629-7.415,11.629-14.515C457.582,178.992,450.918,172.329,442.698,172.329z"
              fill="#0d76ff"
            />
            <path
              d="M284.99,405.52c0.817,6.924,6.686,12.141,13.657,12.141h100.65c6.972,0,12.841-5.217,13.658-12.141l22.375-189.609H262.615   L284.99,405.52z"
              fill="#0d76ff"
            />
          </svg>
        </div>
        <div class="info">
          <div class="name">{{ item.Name }}</div>
          <div class="price">Цена: {{ item.Price }} {{ setting.currency }}</div>
          <div class="counter">
            <span
              class="counter-minus fa fa-minus"
              @click="dec(item, mobileIndex)"
            ></span>
            <span class="counter-quantity">{{
              item.count ? item.count : 0
            }}</span>
            <span
              class="counter-plus fa fa-plus"
              @click="inc(item, mobileIndex)"
            ></span>
          </div>
        </div>
      </div>

      <div
        class="bar-item desktop"
        v-for="(item, index) in groupProducts"
        :key="'bar-item-desktop-' + currentGroupId + '-' + index"
        :style="{ order: item.number }"
        :class="{ added: itemInCart(item) }"
      >
        <div class="blur"></div>
        <div class="image">
          <img :src="item.ImageUrl" :alt="item.name" v-if="item.ImageUrl" />
          <svg
            v-else
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            version="1.1"
            id="Capa_1"
            x="0px"
            y="0px"
            viewBox="0 0 457.582 457.582"
            style="enable-background: new 0 0 457.582 457.582"
            xml:space="preserve"
            width="512px"
            height="512px"
          >
            <path
              d="M11.796,306.42h237.037c1.668,0,3.26-0.711,4.381-1.947s1.67-2.887,1.51-4.548c-4.563-47.249-58.519-84.545-124.41-84.545   S10.467,252.677,5.905,299.926c-0.161,1.662,0.385,3.315,1.507,4.552C8.533,305.715,10.126,306.42,11.796,306.42z"
              fill="#0d76ff"
            />
            <path
              d="M248.832,364.24H11.796c-1.67,0-3.262,0.706-4.384,1.942c-1.122,1.237-1.667,2.891-1.507,4.553   c1.243,12.86,6.148,24.982,13.955,35.816c5.03,6.979,13.114,11.109,21.718,11.109H219.05c8.59,0,16.695-4.14,21.717-11.109   c7.807-10.834,12.712-22.956,13.955-35.816c0.16-1.661-0.388-3.312-1.51-4.548S250.501,364.24,248.832,364.24z"
              fill="#0d76ff"
            />
            '
            <path
              d="M245.744,320.604H14.884C6.664,320.604,0,327.267,0,335.487c0,8.22,6.664,14.883,14.884,14.883h230.86   c8.22,0,14.883-6.664,14.883-14.883C260.627,327.267,253.963,320.604,245.744,320.604z"
              fill="#0d76ff"
            />
            <path
              d="M442.698,172.329c-2.108,0-3.332-2.311-2.22-4.102c1.378-2.222,2.188-4.833,2.219-7.634   c0.094-8.281-7.035-15.055-15.317-15.055h-63.196l4.921-68.878l52.885,22.49c7.782,3.31,16.813-0.519,19.787-8.542   c2.786-7.514-1.15-15.879-8.524-19.016L361.57,41.109c-4.425-1.881-9.486-1.51-13.587,0.998c-4.103,2.508-6.74,6.842-7.083,11.638   l-6.558,91.794h-63.777c-8.281,0-15.41,6.774-15.317,15.055c0.032,2.801,0.841,5.412,2.219,7.634   c1.111,1.791-0.113,4.102-2.22,4.102c-8.22,0-14.883,6.664-14.883,14.884c0,7.101,4.813,14.515,11.629,14.515   c56.444,0,138.568,0,193.96,0c6.816,0,11.629-7.415,11.629-14.515C457.582,178.992,450.918,172.329,442.698,172.329z"
              fill="#0d76ff"
            />
            <path
              d="M284.99,405.52c0.817,6.924,6.686,12.141,13.657,12.141h100.65c6.972,0,12.841-5.217,13.658-12.141l22.375-189.609H262.615   L284.99,405.52z"
              fill="#0d76ff"
            />
          </svg>
        </div>
        <div class="info">
          <div class="name">{{ item.Name }}</div>
          <div class="price">Цена: {{ item.Price }} {{ setting.currency }}</div>
          <div class="counter">
            <span
              class="counter-minus fa fa-minus"
              @click="dec(item, index)"
            ></span>
            <span class="counter-quantity">{{
              item.count ? item.count : 0
            }}</span>
            <span
              class="counter-plus fa fa-plus"
              @click="inc(item, index)"
            ></span>
          </div>
        </div>
      </div>
    </div>
    <div class="bar-footer">
      <div class="basket-step-forward">
        <div class="basket-btn" @click="goNext">
          <span class="btn-icon"></span>
          <span class="btn-label">Купить {{ sum }} {{ setting.currency }}</span>
        </div>
      </div>
    </div>

    <WarningModal
      v-bind:icon="warningImage"
      v-bind:title="warningTitle"
      v-bind:text="warningText"
    />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { types } from '@/types';
import Timer from '@/components/Timer';
import WarningModal from '@/components/modals/WarningModal';
import urlQueryParts from '../../helpers/urlQueryParts';

export default {
  name: 'BarGroup',

  data() {
    return {
      currentGroupId: 0,
      warningImage: '',
      warningTitle: '',
      warningText: '',
      groups: [],
      groupProducts: [],
    };
  },

  components: {
    Timer,
    WarningModal,
  },

  mounted() {
    this.$store
      .dispatch('loadBarPage', {
        theatreId: this.$route.params.theatreId,
        sessionId: this.$route.params.session,
        filmId: this.$route.query.filmId,
      })
      .then(() => this.productsOnLoad);

    try {
      const notificationData = this.notifications(
        this.$route.name,
        (this.session.Format && this.session.Format.Name) || 'test',
      );

      const { Image, Text, Title } = notificationData || {};

      if (
        notificationData &&
        (this.warningImage != Image ||
          this.warningTitle != Title ||
          this.warningText != Text)
      ) {
        const host = process.env.VUE_APP_API_HOST_NEW_WIDGET;

        this.warningImage = `${
          typeof host === 'string' ? host.replace('api.', '') : ''
        }/${Image}`;
        this.warningTitle = Title;
        this.warningText = Text;
        this.$modal.show('warning-modal');
      }
    } catch (e) {
      console.log(e);
    }
  },

  computed: {
    ...mapState([
      'bar',
      'cart',
      'session',
      'user',
      'setting',
      'movie',
      'theatre',
      'barAfterUmounted',
      'promoData',
    ]),
    ...mapGetters(['notifications']),

    productsOnLoad() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.groups = this.bar;
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.groupProducts = this.currentGroup();

      if (this.barAfterUmounted) {
        const { productFolder, productId } = this.barAfterUmounted;

        if (productFolder) {
          const groupIndex = this.bar.findIndex(
            (folder) => String(folder.GroupNumber) == productFolder,
          );

          if (groupIndex != -1) {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.groups = [this.bar[groupIndex]];
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.groupProducts = this.groups[0].Items;

            if (productId) {
              const products = this.groups[0].Items;
              const productIndex = products.findIndex(
                (product) => product.Id == productId,
              );

              if (productIndex != -1) {
                this.cart.bar.length == 0 &&
                  this.inc(products[productIndex], productIndex);
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.groupProducts = this.currentGroup(productIndex);
              }
            }
          }
        }
      }

      return true;
    },

    /* currentGroup() {
      if (this.groups.length) {
        const products = this.groups[`${this.currentGroupId}`].Items;

        if (this.barAfterUmounted && this.barAfterUmounted.productId) {
          const productIndex = products.findIndex(
            (product) => product.Id == this.barAfterUmounted.productId,
          );
          if (productIndex != -1) return [products[productIndex]];
        }

        return products;
      }
    }, */

    sum() {
      const ticketsWithPrice = this.cart.tickets.filter(
        ({ name, price }) => name && price,
      );
      const maxSeats = this.theatre.MaxSeats ? this.theatre.MaxSeats : 5;

      if (
        !this.promoData &&
        ticketsWithPrice.length >= maxSeats &&
        (this.$route.params.theatreId === 'ck8k3jcgs3ch50773nugv3ejn' ||
          this.$route.params.theatreId === 'cl526eslgrikk0929tzb3pe1l')
      ) {
        return this.cart.ticketSum * 0.9 + this.cart.barSum;
      }

      return this.cart.ticketSum + this.cart.barSum;
    },
  },

  methods: {
    currentGroup(productIndex) {
      if (this.groups.length) {
        const products = this.groups[`${this.currentGroupId}`].Items;

        if (typeof productIndex !== 'undefined')
          return [products[productIndex]];

        return products;
      }
    },
    setCurrentGroupId(index) {
      this.currentGroupId = index;
      this.groupProducts = this.currentGroup();
    },
    isActiveGroup(index) {
      return index == this.currentGroupId;
    },
    goNext() {
      if (this.cart.bar.length) {
        this.$store.dispatch('barReserve', {
          theatreId: this.$route.params.theatreId,
        });
      }

      if (!this.$route.params.session && this.$route.params.theatreId) {
        if (this.cart.bar.length > 0)
          this.$router.push(
            `/${this.$route.params.theatreId}/buy${urlQueryParts(
              this.$route.query,
            )}`,
          );
        else {
          this.$store.commit(
            types.ADD_ERROR,
            'Ваша корзина пуста. Перед продолжением необходимо выбрать товар',
          );
          this.$store.commit(types.CLEAR_ERRORS, 3000);
        }
        return;
      }

      if (
        this.session &&
        this.session.Hall &&
        this.session.Hall.HallType &&
        this.session.Hall.HallType.Name &&
        this.session.Hall.HallType.Name === 'Мероприятия'
      ) {
        this.$router.push(
          `/${this.$route.params.theatreId}/${
            this.$route.params.session
          }/support-cultural-program${urlQueryParts(this.$route.query)}`,
        );
      }

      this.$router.push(
        `/${this.$route.params.theatreId}/${
          this.$route.params.session
        }/buy${urlQueryParts(this.$route.query)}`,
      );
    },

    goBack() {
      if (this.$route.params.session) {
        this.$router.push(
          `/${this.$route.params.theatreId}/${
            this.$route.params.session
          }/hall${urlQueryParts(this.$route.query)}`,
        );

        return;
      }

      this.$store.dispatch('logBack');

      if (this.barAfterUmounted) {
        const { selectCity, selectTheatre, productFolder, productId } =
          this.barAfterUmounted;
        if (selectCity || selectTheatre || productFolder || productId) {
          let query = {};
          if (selectCity) query.cityId = selectCity;
          if (selectTheatre) query.theatreId = selectTheatre;
          if (productFolder) query.productFolder = productFolder;
          if (productId) query.productId = productId;
          this.$router.push(`/bar${urlQueryParts(query)}`);

          return;
        }
      }

      if (this.$route.params.theatreId) {
        this.$router.push(`/bar${urlQueryParts(this.$route.query)}`);

        return;
      }
    },

    itemInCart: (item) => item.count,

    inc(item, index) {
      let itemInCart = this.cart.bar.find(
        (itemInBarFormCart) => itemInBarFormCart.Id === item.Id,
      );

      if (!itemInCart) {
        this.$store.commit(types.ADD_BAR_TO_CART, {
          item: item,
          index: index,
        });
      } else {
        let cartIndex = this.cart.bar.findIndex(
          (itemBarInCart) => itemBarInCart.Id === item.Id,
        );

        this.$store.commit(types.CHANGE_BAR_IN_CART, {
          index: cartIndex,
          count: 1,
        });
      }

      this.$store.dispatch('postReserveBarLog', { item, type: 'ADD_BAR_ITEM' });
    },

    dec(item) {
      let itemInCart = this.cart.bar.find(
        (itemInBarFormCart) => itemInBarFormCart.Id === item.Id,
      );

      if (itemInCart) {
        if (itemInCart.count < 1) return;

        let cartIndex = this.cart.bar.findIndex(
          (itemBarInCart) => itemBarInCart.Id === item.Id,
        );
        if (itemInCart.count > 1) {
          this.$store.commit(types.CHANGE_BAR_IN_CART, {
            index: cartIndex,
            count: -1,
          });
        } else {
          this.$store.commit(types.REMOVE_BAR_FROM_CART, cartIndex);
        }
      }

      this.$store.dispatch('postReserveBarLog', {
        item,
        type: 'REMOVE_BAR_ITEM',
      });
    },
  },
};
</script>

<styles src="./BarGroup.scss" lang="scss"></styles>
